<div
  class="ContactForm theme-checkbox theme-form-field"
  colorScheme="contactForm.main"
>
  @if (submitStatus !== 'success') {
    <form
      #form="ngForm"
      [formGroup]="contactForm"
      class="ContactForm__form theme-form-field"
      (ngSubmit)="submit()"
    >
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.first-name.label">First name</mat-label>
              <input data-qa-id="contactFirstName" data-testid="contactFirstName" matInput placeholder="First name" i18n-placeholder="@@contact-form.input.first-name.placeholder" required formControlName="first_name">
              @if (firstName?.errors?.['required']) {
                <mat-error i18n="@@contact-form.input.first-name.error">First name is required</mat-error>
              }
              @else if (firstName?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.last-name.label">Last name</mat-label>
              <input data-qa-id="contactLastName" data-testid="contactLastName" matInput placeholder="Last name" i18n-placeholder="@@contact-form.input.last-name.placeholder" required formControlName="last_name">
              @if (lastName?.errors?.['required']) {
                <mat-error i18n="@@contact-form.input.last-name.error">Last name is required</mat-error>
              }
              @else if (lastName?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.email.label">E-mail</mat-label>
              <input data-qa-id="contactEmail" data-testid="contactEmail" matInput placeholder="E-mail" i18n-placeholder="@@contact-form.input.email.placeholder" required formControlName="email">
              @if (email?.errors?.['required']) {
                <mat-error i18n="@@contact-form.input.email.error-required">Email is required</mat-error>
              }
              @else if (email?.errors?.['email']) {
                <mat-error i18n="@@contact-form.input.email.error-invalid">Email is invalid</mat-error>
              }
              @else if (email?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.phone.label">Phone</mat-label>
              <input data-qa-id="contactPhone" data-testid="contactPhone" matInput placeholder="Phone" i18n-placeholder="@@contact-form.input.phone.placeholder" required formControlName="phone" mask="(AAA) AAA-AAAA||+AAAAAAAAAAAAAAA" [validation]="false">
              @if (phone?.errors?.['required']) {
                <mat-error i18n="@@contact-form.input.phone.error-required">Phone is required</mat-error>
              }
              @else if (phone?.errors?.['pattern']) {
                <mat-error i18n="@@contact-form.input.phone.error-invalid">Phone is invalid</mat-error>
              }
              @else if (phone?.errors?.['minlength']) {
                <mat-error i18n="@@contact-form.input.phone.error-invalid">Phone is invalid</mat-error>
              }
              @else if (phone?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.company.label">Company</mat-label>
              <input data-qa-id="contactCompany" data-testid="contactCompany" matInput placeholder="Company name" i18n-placeholder="@@contact-form.input.company.placeholder" required formControlName="company_name">
              @if (company?.errors?.['required']) {
                <mat-error i18n="@@contact-form.input.company.error">Company name is required</mat-error>
              }
              @else if (company?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          @if (type() === 'asset') {
            <div class="cell medium-12 offer">
              <mat-form-field appearance="outline">
                <mat-label i18n="@@contact-form.input.my-offer.label">My Offer</mat-label>
                <input
                  data-qa-id="offer"
                  data-testid="offer"
                  matInput
                  placeholder="My Offer"
                  i18n-placeholder="@@contact-form.input.my-offer.placeholder"
                  formControlName="offer_price_native"
                  (input)="onOfferInput($event)"
                  (keydown)="onOfferKeydown($event)"
                />
                @if (offer?.errors?.['max']) {
                  <mat-error i18n="@@contact-form.input.max-value-exceeded">Maximum value exceeded</mat-error>
                }
                <mat-hint>{{offerHintComputed()}}</mat-hint>
              </mat-form-field>
            </div>
          }
          <div class="cell medium-12">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@contact-form.input.comment.label">Comment (optional)</mat-label>
              <textarea data-qa-id="contactMessage" data-testid="contactMessage" matInput placeholder="Message" i18n-placeholder="@@contact-form.input.comment.placeholder" formControlName="message" rows="3"></textarea>
              @if (message?.errors?.['maxlength']) {
                <mat-error i18n="@@contact-form.input.max-chars-exceeded">Maximum character limit exceeded</mat-error>
              }
            </mat-form-field>
          </div>
          @if (acknowledgementEnabled() && acknowledgement_agreement) {
            <div class="cell medium-12">
              <mat-form-field appearance="outline" class="mat-form-field--clear">
                <input matInput formControlName="acknowledgement_agreement" [hidden]="true">
                <mat-checkbox
                  formControlName="acknowledgement_agreement" data-testid="contactAcknowledge">
                  <div [innerHTML]="i18n.get(customAcknowledgementText())"></div>
                </mat-checkbox>
                @if (acknowledgement_agreement.errors?.['required']) {
                  <mat-error i18n="@@contact-form.acknowledgement-error">Please acknowledge the agreement to continue</mat-error>
                }
              </mat-form-field>
            </div>
          }
        </div>
        @if (!hideSubmitButton()) {
          <app-button
            btn-large
            btn-elevated
            [disabled]="disabled"
            colorScheme="contactForm.buttons"
          >
            <span
              data-testid="contactSubmit"
              i18n="@@contact-form.send-button.label"
            >Send message</span>
          </app-button>
        }
        </div>
     </form>
  } @else {
    <div class="ContactForm__success">
      <div class="icon-bg"><mat-icon class="material-icons-outlined icon-large">mark_email_read</mat-icon></div>
      <h3 data-testid="successTitle" class="ContactForm__header">{{i18n.get(successTitle())}}</h3>
      <p data-testid="successBody" class="ContactForm__copy">{{i18n.get(successBody())}}</p>
      @if (withCloseButton()) {
        <app-button
          btn-large
          btn-elevated
          (click)="closeForm.emit()"
          colorScheme="contactForm.main"
        >
          <span
            i18n="@@contact-form.close-button.label"
            data-testid="closeButton"
          >Close</span>
        </app-button>
      }
  </div>
  }
</div>